export const deleteUndefinedOrNullProperties = (obj: object) =>
  Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== undefined && obj[key] !== null) {
      return { ...acc, [key]: obj[key] }
    }
    return acc
  }, {})
